import { handleUnauthorized } from "../services/utils"

type TreatedResponse = Omit<
  Response,
  'json' | 'text' | 'blob' | 'arrayBuffer' | 'formData' | 'clone' | 'body'
> & {
  data: any
}

const treatResponse = async (response: Response): Promise<TreatedResponse> => {
  if (response.status === 401) {
    handleUnauthorized()
    throw new Error("Unauthorized")
  }

  const proto = Object.getOwnPropertyNames(Object.getPrototypeOf(response))

  const base = proto.reduce((acc: any, key) => {
    try {
      const value = (response as any)[key]
      if (typeof value !== "function") acc[key] = value
    } catch (_) {}
    return acc
  }, {})

  base.ok = response.ok

  try {
    return { ...base, data: await response.json() }
  } catch (e) {
    console.log("erro: ", e)
    return { ...base, data: { error: "unknown error" } }
  }
}

export default treatResponse
